import { lazy } from 'react';

export const SubmitRGReviewStatusForm = lazy(
  () => import('./SubmitRgReviewStatusForm'),
);
